var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-timepicker',{attrs:{"id":"timeselection","hide-clear-button":"","placeholder":"Select Time","hour-label":"hour","minute-label":"minute","minute-interval":"5","format":"hh:mm A"},model:{value:(_vm.selectedTime),callback:function ($$v) {_vm.selectedTime=$$v},expression:"selectedTime"}})
}
var staticRenderFns = []

export { render, staticRenderFns }